import autoComplete from "bootstrap-autocomplete";
import { Button as Button, Dropdown as Dropdown, ScrollSpy as ScrollSpy, Tab as Tab, Collapse as Collapse } from 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import InfiniteScroll from "infinite-scroll";
import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
Swiper.use([Autoplay, Navigation, Pagination]);
import "swiper/swiper-bundle.css";
import WOW from 'wowjs';
import Sticky from 'sticky-js';
import AOS from "aos";
import "aos/dist/aos.css";
import './styles.scss'

window.wow = new WOW.WOW({
  live: false,
});
window.wow.init();

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    if (window.scrollY > 150) {
      document.getElementById("header").classList.add("scrolled");
    } else {
      document.getElementById("header").classList.remove("scrolled");
    }
  });
});

$( document ).ready( function() {

  $('#filter-title').click(function() {
    if ($(window).width() <= 767) {
        $('#filter-title h3').toggleClass('filter-open'); // Toggle the class immediately
        $('#filters').slideToggle();
    }
});

  if ($('body').hasClass('paged')) {
    var loadMorePrev = $('.blog_archive_block, .product_archive_block[data-direction="prev"]');
    if (loadMorePrev.length) {
      // Element exists, scroll to it
      $(window).scrollTop(loadMorePrev.offset().top);
    } 
  }
  
  $('#search-filter').on('change', function() {
    var type = $(this).val();
    if (type === 'products') {
        $('.product-card').parent().show();
        $('.article-card').parent().hide();
    } else if (type === 'articles') {
        $('.product-card').parent().hide();
        $('.article-card').parent().show();
    } else {
        $('.product-card').parent().show();
        $('.article-card').parent().show();
    }
});

  var $salesBanner = $('.sales-banner');
  var textLength = $salesBanner.text().length;

  if (textLength <= 10) {
    $salesBanner.css('font-size', '28px');
  } else if (textLength <= 20) {
    $salesBanner.css('font-size', '22px');
  } else {
    $salesBanner.css('font-size', '20px');
  }

  function setbannerBackground() {
    $('.swiper-slide .inner .bg').each(function() {
        var bgLarge = $(this).data('bg-large');
        var bgMedium = $(this).data('bg-medium');
        var bgSmall = $(this).data('bg-small');

        if (window.innerWidth <= 767.98) {
            $(this).css('background-image', 'url(' + bgSmall + ')');
        } else if (window.innerWidth <= 991.98) {
            $(this).css('background-image', 'url(' + bgMedium + ')');
        } else {
            $(this).css('background-image', 'url(' + bgLarge + ')');
        }
    });
  }

  function setAdvertisementBackground() {
    $('.advert-content .bg').each(function() {
        var bgLarge = $(this).data('bg-large');
        var bgSmall = $(this).data('bg-small');

        if (window.innerWidth <= 767.98) {
            $(this).css('background-image', 'url(' + bgSmall + ')');
        } else {
            $(this).css('background-image', 'url(' + bgLarge + ')');
        }
    });
  }

  setbannerBackground();
  setAdvertisementBackground();

  $(window).resize(function() {
      setbannerBackground();
      setAdvertisementBackground();
  });

  var img = $(".main-image #product-img");
  var result = $("#img-result");
  var lens = $("<div id='zoom-lens'></div>");
  var overlay = $("<div id='zoom-overlay'>Click to Zoom</div>");
  $(".main-image").append(lens, overlay);

  lens.css({
    "backgroundImage": "url(" + img.attr("src") + ")",
    "backgroundRepeat": "no-repeat",
    "backgroundSize": (img.width() * 3) + "px " + (img.height() * 3) + "px",
    "border": "1px solid #d4d4d4",
    "width": "100px",
    "height": "100px",
    "position": "absolute",
    "display": "none"
  });

  overlay.css({
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "100%",
    "backgroundColor": "rgba(0, 69, 124, 0.8)",
    "color": "#fff",
    "font-family": "'Ubuntu'",
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "fontSize": "20px",
    "cursor": "pointer",
    "display": "none"
  });

  result.css({
    "display": "none",
  });

  img.parent().on('mouseenter', function() {
    if (window.innerWidth > 992) {
      overlay.css("display", "flex");
    }
  });

  img.parent().on('mouseleave', function() {
    overlay.css("display", "none");
    lens.css("display", "none");
    result.css("display", "none");
  });

  img.parent().on('click', function() {
    if (window.innerWidth > 992) {
      lens.css("display", "block");
      result.css("display", "block");
      overlay.css("display", "none");
    }
  });

  img.parent().mousemove(moveLens);
  lens.mousemove(moveLens);

  function moveLens(e) {
    var pos = getCursorPos(e);
    var positionLeft = pos.x - (lens.width() / 2);
    var positionTop = pos.y - (lens.height() / 2);

    if (positionLeft < 0) {positionLeft = 0;}
    if (positionTop < 0) {positionTop = 0;}
    if (positionLeft > img.width() - lens.width()) {positionLeft = img.width() - lens.width();}
    if (positionTop > img.height() - lens.height()) {positionTop = img.height() - lens.height();}

    lens.css({
      "backgroundImage": "url(" + img.attr("src") + ")",
      "left": positionLeft + "px",
      "top": positionTop + "px",
      "backgroundPosition": "-" + (positionLeft * 3) + "px -" + (positionTop * 3) + "px"
    });

    result.css({
      "backgroundImage": "url(" + img.attr("src") + ")",
      "backgroundSize": (img.width() * 3.6) + "px " + (img.height() * 3.6) + "px",
      "backgroundPosition": "-" + (positionLeft * 3) + "px -" + (positionTop * 3) + "px"
    });
  }

  function getCursorPos(e) {
    var a = img[0].getBoundingClientRect();
    var x = e.pageX - a.left;
    var y = e.pageY - a.top;
    x = x - window.pageXOffset;
    y = y - window.pageYOffset;
    return {x : x, y : y};
  }
  /*
  $("header .header-bottom .menu-container .menu>li.dropdown > a").on( 'click touch', function(e) {
    e.preventDefault();
    if($( this ).parents( 'li' ).hasClass( 'activated' ) ) {
      $(this).parents("li").removeClass("activated");
    } else {
      $("header .header-bottom .menu-container .menu>li.dropdown.activated").removeClass( 'activated' );
      $(this).parents("li").addClass("activated");
    }
  });
  */

  AOS.init({
    offset: 60,
    delay: 300,
    duration: 600
  });

  $('.burger').on( 'click touch', function(e) {
    e.preventDefault();
    $(".search-toggle").removeClass("active");
    $(".header-middle .search").fadeOut(300);
    $( 'header' ).toggleClass( 'open' );
    $(".burger-button").toggleClass("active");
    $(".mobile-menu").toggle();
  })

  $("#nav-tabs-dropdown").on( 'change', function(e) {
    e.preventDefault();
    var id = $( this ).val();
    $('[data-bs-toggle="tab"][data-bs-target="#' + id + '"]').trigger("click");
  })

  $(".mobile-menu .menu li.menu-item-has-children > a").on(
    "click touch",
    function (e) {
      e.preventDefault();
      $(this).parent("li").find(".sub-menu-wrapper").first().show(0);
    }
  );

  $(".mobile-menu a.back").on("click touch", function (e) {
    e.preventDefault();
    $(this).parent(".sub-menu-wrapper").hide(0);
  });

  $(".search-toggle").on( 'click touch', function(e) {
    e.preventDefault();
    $("header").removeClass("open");
    $(".burger-button").removeClass("active");
    $(".mobile-menu").fadeOut(300);
    $( this ).toggleClass( 'active' );
    $(".header-middle .search").fadeToggle(300);
  })

  if(window.location.hash) {
    var target = window.location.hash;
    window.wow.init();
    $("html, body").animate({ scrollTop: $(target).offset().top - 89 }, 0);
  }

  $(function () {
    $('.current-menu-item a[href*="#"]:not([href="#"])').click(function () {
      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html, body").animate(
            { scrollTop: $(target).offset().top - 89 },
            0
          );
          return false;
        }
      }
    });
  });

  $('.arrow').click(function () {
    var target = $(this.hash);
    target = target.length
      ? target
      : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      $("html, body").animate(
        { scrollTop: $(target).offset().top - 80 },
        0
      );
      return false;
    }
  });

  const sliderSwiper = new Swiper(".header_slider_block .swiper", {
    loop: true,
    effect: "fade",
    autoHeight: true,
    autoplay: {
      delay: 5000
    },
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".header_slider_block .swiper-button-next",
      prevEl: ".header_slider_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0
  });

  const imagesliderSwiper = new Swiper(".image_carousel_block .swiper", {
    loop: true,
    effect: "fade",
    autoHeight: true,
    autoplay: {
      delay: 5000
    },
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".image_carousel_block .swiper-button-next",
      prevEl: ".image_carousel_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1.3,
    centeredSlides: true,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 1.8
      }
    }
  });

  let swiper;
window.globals = {};
const body = document.getElementsByTagName('body')[0];
const lightboxImages = document.querySelectorAll("[lightbox-toggle] img");
const initLightbox = (lightboxImages.length > 0);

const destroySwiper = (swiper, timeout) => {
  setTimeout(() => {
    swiper.destroy();
  }, timeout);
};

const createLightboxSkeleton = () => {
  // Create skeleton for lightbox
  const lightbox = document.createElement('div');
  const lightboxContainer = document.createElement('div');
  const lightboxClose = document.createElement('div');
  const swiperContainer = document.createElement('div');
  const swiperWrapper = document.createElement('div');
  const swiperBtnNext = document.createElement('div');
  const swiperBtnPrev = document.createElement('div');
  const swiperPagination = document.createElement('div');

  // Add classes
  lightbox.classList.add('c-lightbox');
  lightboxContainer.classList.add('c-lightbox__container');
  lightboxClose.classList.add('c-lightbox__close');
  lightboxClose.setAttribute('tabindex', '0');
  lightboxClose.innerHTML = 'X';
  swiperContainer.classList.add('swiper-container');
  swiperWrapper.classList.add('swiper-wrapper');
  swiperBtnNext.classList.add('swiper-button-next');
  swiperBtnPrev.classList.add('swiper-button-prev');
  swiperPagination.classList.add('swiper-pagination');

  // Append created divs
  lightboxContainer.appendChild(lightboxClose);
  swiperContainer.appendChild(swiperWrapper);
  swiperContainer.appendChild(swiperBtnNext);
  swiperContainer.appendChild(swiperBtnPrev);
  swiperContainer.appendChild(swiperPagination);
  lightboxContainer.appendChild(swiperContainer);
  lightbox.appendChild(lightboxContainer);
  body.appendChild(lightbox);

  // Set variables to reference the lightbox
  globals.lightboxRef = document.querySelector('.c-lightbox');
  globals.swiperWrapperRef = document.querySelector(
    '.c-lightbox .swiper-wrapper',
  );
};

if (initLightbox) {
  createLightboxSkeleton();

  // The rest of the code will go here
  lightboxImages.forEach((el, index) => {
    // Add click function to lightbox images
    el.addEventListener('click', imageClick, false);
  
    function imageClick() {
      // Clear swiper before trying to add to it
      globals.swiperWrapperRef.innerHTML = '';
  
      // Loop through images with lightbox data attr
      // Create html for lightbox carousel
      lightboxImages.forEach((img) => {
        // Create clone of current image in loop
        const image = img.cloneNode(true);
        // Create divs
        const slide = document.createElement('div');
        const imageContainer = document.createElement('div');
        // Add classes
        slide.classList.add('swiper-slide');
        imageContainer.classList.add('c-lightbox__image');
        // Append images to the slides, then slides to swiper wrapper
        imageContainer.appendChild(image);
        slide.appendChild(imageContainer);
        globals.swiperWrapperRef.appendChild(slide);
      });
  
      // Init Swiper
      swiper = new Swiper('.c-lightbox .swiper-container', {
        initialSlide: index,
        loop: true,
        autoplay: {
          delay: 5000
        }, 
        slidesPerView: 1,
        speed: 750,
        spaceBetween: 16,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        zoom: true,
        fadeEffect: {
          crossFade: false,
        },
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        mousewheel: {
          sensitivity: 1,
          forceToAxis: true,
          invert: true,
        },
      });
  
      // Add the class to open the lightbox
      // Add overflow hidden to the body to prevent scrolling
      globals.lightboxRef.classList.add('open');
      body.classList.add('overflowHidden');
    }
  });

  // Close lightbox on click
document.addEventListener('click', ({ target }) => {
  if (target.matches('.c-lightbox__close')) {
    destroySwiper(swiper, 250);
    globals.lightboxRef.classList.remove('open');
    body.classList.remove('overflowHidden');
  }
}, false);

// Close lightbox on escape key press
document.addEventListener('keydown', ({ key }) => {
  if (key === 'Escape') {
    destroySwiper(swiper, 250);
    globals.lightboxRef.classList.remove('open');
    body.classList.remove('overflowHidden');
  }
});
}

  const campaignHeaderSwiper = new Swiper(".campaign_header_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".campaign_header_block .swiper-button-next",
      prevEl: ".campaign_header_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
  });

  const exploreSwiper = new Swiper(".explore_block .grid .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".explore_block .grid .swiper-button-next",
      prevEl: ".explore_block .grid .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
  });

  const exploreCtaSwiper = new Swiper(".explore_block .cta-slider .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    autoplay: {
      delay: 5000
    },
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".explore_block .cta-slider .swiper-button-next",
      prevEl: ".explore_block .cta-slider .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 30,
  });

  const featuredSliderSwiper = new Swiper(".featured_slider_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".featured_slider_block .swiper-button-next",
      prevEl: ".featured_slider_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    }
  });

  const cubeblockswiper = new Swiper(".cube_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".cube_block .swiper-button-next",
      prevEl: ".cube_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 3
      }
    }
  });

  const testimonialsSliderSwiper = new Swiper(".testimonials_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".testimonials_block .swiper-button-next",
      prevEl: ".testimonials_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });

  const contentSliderSwiper = new Swiper(".slider_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".slider_block .swiper-button-next",
      prevEl: ".slider_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });

  const featuredProductsSwiper = new Swiper(".featured_products_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".featured_products_block .swiper-button-next",
      prevEl: ".featured_products_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 2,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 4,
      }
    },
  });

  const postBlockSwiper = new Swiper(".post_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".post_block .swiper-button-next",
      prevEl: ".post_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });

  const relatedSwiper = new Swiper(".related_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".related_block .swiper-button-next",
      prevEl: ".related_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
    },
  });

  const storySwiper = new Swiper(".story_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    centeredSlides: true,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".story_block .swiper-button-next",
      prevEl: ".story_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 4
      },
      1100: {
        slidesPerView: 5
      }
    },
  });

  storySwiper.on("slideChange", function (e) {
    $(".story-content").fadeOut(300);
  });

  storySwiper.on("slideChangeTransitionEnd", function (e) {
    var target = $(".story_block .swiper-slide-active a").attr("href");
    $(target).fadeIn(300);
  });

  $(".story-link").on( 'click touch', function(e) {
    e.preventDefault();
  })
  
  const featuredArticlesSwiper = new Swiper(".featured_articles_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".featured_articles_block .swiper-button-next",
      prevEl: ".featured_articles_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0
  });

  const categoryBannersSwiper = new Swiper(".banners .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".banners .swiper-button-next",
      prevEl: ".banners .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 1,
    spaceBetween: 0,
  });

  const prodCategorySwiper = new Swiper(".product_category_block .swiper", {
    loop: true,
    autoplay: {
      delay: 5000
    },
    effect: "fade",
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".product_category_block .swiper-button-next",
      prevEl: ".product_category_block .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 2,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
      },
      1100: {
        slidesPerView: 6,
      },
    },
  });

//   const archiveTagSwiper = new Swiper('.tag-slider', {
//     slidesPerView: 1,
//     spaceBetween: 5,
//     autoplay: {
//       delay: 5000
//     },
//     navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//     },
//     breakpoints: {
//         768: {
//             slidesPerView: 2,
//             spaceBetween: 10,
//         },
//         480: {
//             slidesPerView: 1,
//             spaceBetween: 10,
//         },
//     },
// });

var archiveTagSwiper = new Swiper('.tag-slider', {
  slidesPerView: 'auto',
  spaceBetween: 10,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
});


  const prodGallerySwiper = new Swiper(".gallery-slider .swiper", {
    loop: false,
    autoplay: {
      delay: 5000
    },
    autoHeight: false,
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: ".gallery-slider .swiper-button-next",
      prevEl: ".gallery-slider .swiper-button-prev",
    },
    speed: 1000,
    slidesPerView: 4,
    spaceBetween: 10,
    breakpoints: {
      599: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 5,
      },
      1100: {
        slidesPerView: 6,
      },
    },
  });
  $(".gallery-slider .image").on( 'click touch', function(e) {
    e.preventDefault();
    var img = $( this ).attr( 'href' );
    $(".main-image img").attr( 'src', img );
  })

  $(".video-popup").magnificPopup({
    type: "iframe",
    mainClass: "mfp-fade",
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    iframe: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<a href="#" class="close-modal"><span></span><span></span></a>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        "</div>",
    },
  });

  var check_cookie = $.cookie('product-recall' );
  if ($("#product-recall-modal").length > 0 && check_cookie == undefined) {
    $.magnificPopup.open({
      items: {
        src: "#product-recall-modal",
      },
      type: "inline",
    });
  }

  $('.product-contact-popup').click(function() {
      var popupid = $(this).data('popup');

      $.magnificPopup.open({
        items: {
          src: "#product-contact-modal-" + popupid,
        },
        type: "inline",
      });
  });

  $(".popup-cookie-dismiss").on( 'click touch', function(e) {
    e.preventDefault();
    $.cookie("product-recall", "yes", { expires: 1 });
    $.magnificPopup.close();
  })



  $(".popup-modal").magnificPopup({
    type: "inline",
    preloader: false
  });
  $(document).on("click", ".popup-modal-dismiss", function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });


  $("#main-map > path, #main-map > g").on("click touch", function (e) {
    e.preventDefault();
    var id = $(this).attr("id").toLowerCase();
    $("#region .empty").fadeOut(300);
    $("#region .contact").fadeOut(300);
    $("#region .contact").removeClass('blue green mid-blue purple red light-blue grey orange light-green');
    $.ajax({
      type: "post",
      dataType: "json",
      url: myAjax.ajaxurl,
      data: {
        action: "get_contact_info",
        region: $(this).attr("id"),
        nonce: $("#contact_nonce").val(),
      },
      success: function (response) {
        if( response.colour ) {
          $("#region .contact." + id).addClass(response.colour);
          $("#region .contact." + id).fadeIn(300);
        }
        
        if( $("#region .contact." + id).length < 1 ) {
          $("#region .empty").fadeIn(300);
        }
      },
    });
  });

  var id = "";
  $("#main-map > path, #main-map > g").mouseover(function (e) {
    var newId = $(this).attr("id").toLowerCase();
    if (id != newId) {
      var mouseX = e.pageX + 30;
      var mouseY = e.pageY - 30;
      var id = newId;
      var formattedId = id.replace("-", " ");
      formattedId = formattedId.replace("-", " ");
      formattedId = formattedId.replace("-", " ");
      formattedId = formattedId.replace("-1", "");
      formattedId = formattedId.replace("-2", "");
      $("#territory-tooltip")
        .empty()
        .text(formattedId)
        .css({ top: mouseY, left: mouseX })
        .show();
    }
  });

  $("#region-dropdown").on( 'change', function(e){
    e.preventDefault();
    var id = $( this ).val();
    $("#region .empty").fadeOut(300);
    $("#region .contact").fadeOut(300);
    $("#region .contact").removeClass(
      "blue green mid-blue purple red light-blue grey orange light-green"
    );
    $.ajax({
      type: "post",
      dataType: "json",
      url: myAjax.ajaxurl,
      data: {
        action: "get_contact_info",
        region: id,
        nonce: $("#contact_nonce").val(),
      },
      success: function (response) {
        if (response.colour) {
          $("#region .contact." + id).addClass(response.colour);
          $("#region .contact." + id).fadeIn(300);
        }

        if ($("#region .contact." + id).length < 1) {
          $("#region .empty").fadeIn(300);
        }
      },
    });
  });

  $(".map").mouseleave(function (e) {
    $("#territory-tooltip").hide();
  });

  $("#postcode-search-form").on( 'submit', function(e) {
    e.preventDefault();
    $("#postcode .empty").fadeOut(300);
    $("#postcode .contact").fadeOut(300);
    $("#postcode .contact").removeClass('blue green mid-blue purple red light-blue grey orange light-green');
    var postcode = $("#postcode-search-form input[name='postcode']").val();
    $.ajax({
      type: "post",
      dataType: "json",
      url: myAjax.ajaxurl,
      data: {
        action: "get_contact_info_by_postcode",
        postcode: postcode,
        nonce: $("#contact_nonce").val(),
      },
      success: function (response) {
        if (response.region) {
          var id = response.region.toLowerCase();
          var formattedId = id.replace(/-1$/, "").replace(/-2$/, "").replace(/-/g, " ");
          // Properly capitalize each word
          formattedId = formattedId.split(' ').map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          }).join(' ');
          $("#postcode .contact." + id + " .contact-region").empty().text(formattedId);
          $("#postcode .contact." + id).addClass(response.colour);
          $("#postcode .contact." + id).fadeIn(300);
        } else {
          $("#postcode .empty").fadeIn(300);
        }
      },
    });
  });

  $("#search-text").autoComplete({
    resolver: "custom",
    bootstrapVersion: "5",
    formatResult: function (item) {
      return {
        value: item.id,
        text: item.text,
        html: [
          item.html
        ]
      };
    },
    events: {
      search: function (qry, callback) {
        $.ajax({
          url: myAjax.ajaxurl,
          type: "post",
          dataType: "json",
          data: {
            action: "search_form",
            type: $("#search-type").val(),
            search: qry,
            nonce: $("#search_nonce").val(),
          }
        }).done(function (res) {
          callback(res.results);
        });
      }
    }
  });

  $("#search-text").on("autocomplete.select", function (evt, item) {
    var url = item.url;
    window.location.href = url;
  });
  
		

  /* PAGINATION */
  if ($(".articles-list-container").length > 0 && $( '.articles-list-container' ).length > 0 ) {
    var item_length = $('.articles-list-container .article-container').length;
  	$('.pagination .shown').text(item_length);
  	
    $('.js-load-more').click(function(event) {
    	event.preventDefault();
    	var paged = $(this).data('paged');
    	var direction = $(this).data('direction'); 

    	if(direction == 'next') {
    		paged++;
    	} else if(direction == 'prev'){
    		paged--;
    	}

    	var data = {
  			'action': 'load_more',
  			'paged': paged,
  			'direction': direction,
  			'query': site_ajax.query_vars,
		};
		$.post(site_ajax.ajaxurl, data, function(output) {
			var content = $.parseJSON(output);
			
			history.replaceState({ page: paged }, 'title ' + paged, site_ajax.url + '/page/' + paged + '/');

			if(content.direction == 'next') {
				$('.articles-list-container').append(content.html);
				$('.js-load-more[data-direction="next"]').data('paged', paged);
			} else if(content.direction == 'prev') {
				$('.articles-list-container').prepend(content.html);
				$('.js-load-more[data-direction="prev"]').data('paged', paged);
			}
			if(content.pages == paged) {
				$('.js-load-more[data-direction="next"]').hide();
			}
			if(paged == 1) {
				$('.js-load-more[data-direction="prev"]').hide();
			} 
		}).then(function() {		
			var item_length = $('.articles-list-container .article-container').length;
  			$('.pagination .shown').text(item_length);
		});
    });
    }

    $("#sort").on("change", function () {
      $(this).parents("form").submit();
    });


    var sticky = new Sticky(".sticky");

    if ($("#counter-box").length > 0 ) {
      var a = 0;
      $(window).scroll(function () {
        var oTop = $("#counter-box").offset().top - window.innerHeight;
        if (a == 0 && $(window).scrollTop() > oTop) {
          $(".counter").each(function () {
            var $this = $(this),
              countTo = $this.attr("data-number");
            $({
              countNum: $this.text(),
            }).animate(
              {
                countNum: countTo,
              },

              {
                duration: 2000,
                easing: "swing",
                step: function () {
                  //$this.text(Math.ceil(this.countNum));
                  $this.text(Math.ceil(this.countNum).toLocaleString("en"));
                },
                complete: function () {
                  $this.text(Math.ceil(this.countNum).toLocaleString("en"));
                  //alert('finished');
                },
              }
            );
          });
          a = 1;
        }
      });
    }

    $(".footer-menu h3").on( 'click touch', function(e){
      e.preventDefault();
      if( $( window ).width() < 768 ) {
        $( this ).toggleClass( "active" );
        $( this ).parents( '.footer-menu' ).find( 'ul' ).slideToggle();
      }
    })


    $("header .header-bottom .menu-container .menu > li > .sub-menu-wrapper.columns .col-lg-9 > .sub-menu > li > a").on( 'click touch', function(e) {
      e.preventDefault();
      $( this ).parents( 'ul' ).find( 'li' ).removeClass( "active" );
      $( this ).parents( 'li' ).addClass( 'active' );
    })

    $(".syncHeights").syncHeight({ updateOnResize: true });

});